// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Set_Serialized from "../Data.Set.Serialized/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_Menu_Types from "../Restaumatic.Menu.Types/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var MostExpensive = /* #__PURE__ */ (function () {
    function MostExpensive() {

    };
    MostExpensive.value = new MostExpensive();
    return MostExpensive;
})();
var Average = /* #__PURE__ */ (function () {
    function Average() {

    };
    Average.value = new Average();
    return Average;
})();
var SplitPizzaSettings = function (x) {
    return x;
};
var eqBasePrice = {
    eq: function (x) {
        return function (y) {
            if (x instanceof MostExpensive && y instanceof MostExpensive) {
                return true;
            };
            if (x instanceof Average && y instanceof Average) {
                return true;
            };
            return false;
        };
    }
};
var eqSplitPizzaSettings = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(eqBasePrice)(x.basePrice)(y.basePrice) && x.enableToppingExchange === y.enableToppingExchange && Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.extraCharge)(y.extraCharge) && x.maxSplits === y.maxSplits && Data_Eq.eq(Data_Set_Serialized.eqSet(Restaumatic_Menu_Types.eqPizzaSize))(x.sizes)(y.sizes);
        };
    }
};
var newtypeSplitPizzaSettings = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldSplitPizzaSettings = function (dictHasField) {
    return dictHasField;
};
var genericSplitPizzaSettings = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericBasePrice = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return MostExpensive.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return Average.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.Types.SplitPizzaSettings (line 18, column 1 - line 18, column 73): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof MostExpensive) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Average) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.Types.SplitPizzaSettings (line 18, column 1 - line 18, column 73): " + [ x.constructor.name ]);
    }
};
var showBasePrice = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericBasePrice)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "MostExpensive";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Average";
        }
    })))
};
var showSplitPizzaSettings = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericSplitPizzaSettings)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "basePrice";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "enableToppingExchange";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "extraCharge";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "maxSplits";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "sizes";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Set_Serialized.showSet(Restaumatic_Menu_Types.showPizzaSize)))(Data_Show.showInt))(Data_Money_Rounded.showMoney))(Data_Show.showBoolean))(showBasePrice))))({
        reflectSymbol: function () {
            return "SplitPizzaSettings";
        }
    }))
};
var unscrambleDecodeBasePrice = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericBasePrice)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "MostExpensive";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Average";
        }
    })))(Unscramble_Enum.defaultEnumOptions)
};
var unscrambleDecodeSplitPizzaSettings = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericSplitPizzaSettings)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "basePrice";
        }
    })(unscrambleDecodeBasePrice)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "enableToppingExchange";
        }
    })(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "extraCharge";
        }
    })(Data_Money_Rounded.udecodeMoney)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "maxSplits";
        }
    })(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "sizes";
        }
    })(/* #__PURE__ */ Data_Set_Serialized.udecodeSet(Restaumatic_Menu_Types.ordPizzaSize)(Restaumatic_Menu_Types.unscrambleDecodePizzaSize))(Unscramble.decodeRecordNil)))))))))(Unscramble_Generic.defaultOptions)
};
var encodingOpts = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        unwrapSingleRecordArguments: true,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    };
})();
var encodeBasePrice = {
    encode: /* #__PURE__ */ Foreign_Generic_EnumEncoding.genericEncodeEnum(genericBasePrice)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "MostExpensive";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Average";
        }
    })))(Foreign_Generic_EnumEncoding.defaultGenericEnumOptions)
};
var encodeSplitPizzaSettings = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericSplitPizzaSettings)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "SplitPizzaSettings";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "sizes";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Set_Serialized.encodeSet(Restaumatic_Menu_Types.encodePizzaSize))))({
        reflectSymbol: function () {
            return "maxSplits";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
        reflectSymbol: function () {
            return "extraCharge";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "enableToppingExchange";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
        reflectSymbol: function () {
            return "basePrice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeBasePrice))))))(encodingOpts)
};
var decodeBasePrice = {
    decode: /* #__PURE__ */ Foreign_Generic_EnumEncoding.genericDecodeEnum(genericBasePrice)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "MostExpensive";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Average";
        }
    })))(Foreign_Generic_EnumEncoding.defaultGenericEnumOptions)
};
var decodeSplitPizzaSettings = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericSplitPizzaSettings)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "SplitPizzaSettings";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "sizes";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Set_Serialized.decodeSet(Restaumatic_Menu_Types.ordPizzaSize)(Restaumatic_Menu_Types.decodePizzaSize)))())({
        reflectSymbol: function () {
            return "maxSplits";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
        reflectSymbol: function () {
            return "extraCharge";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())({
        reflectSymbol: function () {
            return "enableToppingExchange";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
        reflectSymbol: function () {
            return "basePrice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeBasePrice))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
export {
    MostExpensive,
    Average,
    SplitPizzaSettings,
    encodingOpts,
    genericBasePrice,
    showBasePrice,
    eqBasePrice,
    decodeBasePrice,
    unscrambleDecodeBasePrice,
    encodeBasePrice,
    genericSplitPizzaSettings,
    showSplitPizzaSettings,
    eqSplitPizzaSettings,
    decodeSplitPizzaSettings,
    unscrambleDecodeSplitPizzaSettings,
    encodeSplitPizzaSettings,
    newtypeSplitPizzaSettings,
    hasFieldSplitPizzaSettings
};
//# sourceMappingURL=index.js.map
